module.exports = __webpack_public_path__ + "img/alp03.d9ca373e.png";